import React from 'react'
import PropTypes from 'prop-types'
import { Paragraph, Title } from '@omnilert/components'
import useStyles from './body-text.style'
import dayjs from 'dayjs'
import { useIntl } from 'react-intl'

const BodyText = ({ item }) => {
  const {
    component,
    emphasis,
    label,
    size,
    text,
    timestamp
  } = item

  const hasLabel = label?.length > 0

  const classes = useStyles({ emphasis })

  const intl = useIntl()

  const formatTime = () => {
    if (!timestamp || !timestamp.seconds) {
      return ''
    }
    const timeFormat = dayjs(timestamp.seconds * 1000).locale(intl.locale)
    const timeString = `${timeFormat.format('LT')}`
    const dateString = `on ${timeFormat.format('LL')}`

    return ` ${timeString} ${dateString}`
  }

  const renderLabel = () => {
    switch (component) {
    case 'title':
      return (
        <Title
          className={[classes.labelText, classes.title]}
          color='var(--card--text__color)'
          size={size}
        >
          {label}
        </Title>
      )
    default:
      return (
        <Paragraph
          className={classes.labelText}
          color='var(--card--text__color)'
          size={size}
        >
          {label}
        </Paragraph>
      )
    }
  }

  const renderText = () => {
    switch (component) {
    case 'title':
      return (
        <Title
          className={classes.title}
          color='var(--card--text__color)'
          size={size}
        >
          {text}
        </Title>
      )
    default:
      return (
        <Paragraph
          className={classes.paragraphText}
          color='var(--card--text__color)'
          size={size}
        >
          {`${text}${formatTime()}`}
        </Paragraph>
      )
    }
  }

  return (
    <div className={classes.cardTextWrapper}>
      {hasLabel && renderLabel()}
      {renderText()}
    </div>
  )
}

BodyText.defaultProps = {
  color: '',
  label: '',
  text: ''
}

BodyText.propTypes = {
  color: PropTypes.string,
  label: PropTypes.string,
  text: PropTypes.string
}

export default BodyText
